import React from 'react';
import styles from "./InformationTooltipWrapper.module.scss";
import { Tooltip } from 'react-tooltip'

// We load this component at a high level in the component tree.
// Hovering on InformationTip components, will place their content inside this component.
// This is bound by id's

export const InformationTooltipWrapper = () => {
    return (
        <Tooltip
            id="information-tooltip"
            className={styles.informationTooltip}
            classNameArrow={styles.informationTooltipArrow}
            delayShow={0}
            delayHide={0}
        />
    )
}
